"use client";

import Link from "next/link";
import { cn } from "@/lib/utils";

export default function FloatingEnquiryButton({
  href,
  label,
  className,
}: {
  href: string;
  label: string;
  className?: string;
}) {
  return (
    <div className={cn("fixed bottom-6 left-6 z-[60] hidden md:block", className)}>
      <Link
        href={href}
        className="inline-flex items-center rounded-full bg-white px-10 py-3.5 text-xs font-medium tracking-[0.2em] uppercase text-black font-body hover:bg-white/90 transition-colors duration-200"
      >
        {label}
      </Link>
    </div>
  );
}